import type { ButtonProps } from "@chakra-ui/react";
import type { TrackProps } from "~/ui/tracked/types";
import { Button } from "~/ui/tracked/form/button";

export function DangerBtn(props: ButtonProps & TrackProps): JSX.Element {
  return <Button colorScheme="red" {...props} />;
}
